'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dialog = require('./Dialog');

var _Dialog2 = _interopRequireDefault(_Dialog);

var _ButtonLight = require('../../../managewidgets/components/button/ButtonLight');

var _ButtonLight2 = _interopRequireDefault(_ButtonLight);

var _Locale = require('../../../Locale');

var _Locale2 = _interopRequireDefault(_Locale);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @type {React.StatelessComponent} */
var AlertDialog = function AlertDialog(props) {
  var formatMessage = props.intl.formatMessage;


  var dialogButtons = function dialogButtons(formatMessage) {
    return [_react2.default.createElement(_ButtonLight2.default, { automationName: 'dismiss', key: 'dismiss', value: formatMessage(_Locale2.default.dismiss), onClick: props.onDismiss })];
  };

  return _react2.default.createElement(_Dialog2.default, (0, _assign2.default)({
    automationName: 'alert',
    header: props.header || formatMessage(_Locale2.default.notification),
    buttons: dialogButtons(formatMessage)
  }, props));
};

AlertDialog.propTypes = (0, _assign2.default)({
  /**
   * Function for the dismiss button
   */
  onDismiss: _propTypes2.default.func
}, _Dialog2.default.propTypes);

exports.default = (0, _reactIntl.injectIntl)(AlertDialog);


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/managewidgets/components/dialogs/AlertDialog.js
// module id = 771
// module chunks = 10